import SrPannel from "./SrPannel.vue";

SrPannel.install = function(Vue) {
  Vue.component(SrPannel.name, SrPannel);
};

export default SrPannel;


// WEBPACK FOOTER //
// ./packages/SrPannel/index.js